import { useEffect, useState } from "react";
import { aiSummary } from "../lib/api";
import { waLink } from "../lib/constants";

export const AiSummaryModal = ({ open, title, items, waNumber = "", onClose }) => {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  const run = async () => {
    setLoading(true); setError(""); setText("");
    try {
      const r = await aiSummary({ title, items });
      setText(r.text || "");
    } catch {
      setError("Gagal membuat ringkasan AI. Coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) run();
    // eslint-disable-next-line
  }, [open]);

  if (!open) return null;

  return (
    <div className="no-print fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl my-auto flex flex-col max-h-[92vh] animate-fade-up" data-testid="ai-summary-modal">
        <div className="px-6 py-4 bg-slate-900 text-white flex justify-between items-center">
          <h3 className="text-base sm:text-lg font-bold flex items-center gap-2"><i className="ph-bold ph-sparkle text-teal-400" /> Ringkasan AI {title ? `— ${title}` : ""}</h3>
          <button onClick={onClose} className="text-slate-300 hover:text-white p-1 rounded-lg hover:bg-white/10" data-testid="ai-summary-close"><i className="ph-bold ph-x text-xl" /></button>
        </div>
        <div className="p-6 overflow-y-auto flex-1 min-h-[12rem]">
          <p className="text-[11px] text-slate-400 mb-3">Menganalisa {items?.length || 0} item. Didukung Gemini.</p>
          {loading && (
            <div className="flex flex-col items-center justify-center py-12 text-slate-500">
              <i className="ph-bold ph-spinner animate-spin text-3xl text-teal-500" />
              <p className="mt-3 text-sm font-semibold">AI sedang menganalisa data...</p>
            </div>
          )}
          {error && <p className="text-sm text-rose-600 font-semibold">{error}</p>}
          {!loading && text && (
            <div className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed space-y-0.5" data-testid="ai-summary-text">
              {text.split("\n").map((line, i) => {
                const clean = line.replace(/\*\*/g, "").replace(/^\s*[\*\-]\s+/, "• ");
                const isHeading = /^#{1,3}\s/.test(line) || (/\*\*/.test(line) && line.trim().endsWith("**"));
                return (
                  <p key={i} className={isHeading ? "font-bold text-slate-900 mt-2" : ""}>{clean.replace(/^#{1,3}\s/, "")}</p>
                );
              })}
            </div>
          )}
        </div>
        <div className="px-6 py-4 border-t border-slate-200 flex justify-between items-center gap-3 flex-wrap">
          <div>
            {waNumber && text && !loading && (
              <a
                href={waLink(waNumber, `*Ringkasan Kondisi${title ? ` — ${title}` : ""}*\n\n${text.replace(/\*\*/g, "")}`)}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold rounded-lg"
                data-testid="ai-summary-wa-btn"
              >
                <i className="ph-bold ph-whatsapp-logo text-base" /> Kirim ke WhatsApp
              </a>
            )}
          </div>
          <div className="flex items-center gap-3">
            <button onClick={run} disabled={loading} className="px-4 py-2 border border-slate-300 text-slate-700 text-xs font-bold rounded-lg hover:bg-slate-50 disabled:opacity-60" data-testid="ai-summary-retry"><i className="ph-bold ph-arrows-clockwise" /> Buat Ulang</button>
            <button onClick={onClose} className="px-5 py-2 bg-slate-800 hover:bg-slate-900 text-white text-xs font-bold rounded-lg">Tutup</button>
          </div>
        </div>
      </div>
    </div>
  );
};
